import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Modal, Button } from '../../components';
import * as S from './NewCustomerAccountPendingPopup.styles';
import { useMediaQuery } from 'beautiful-react-hooks';

const NewCustomerAccountPendingPopup = ({ isOpen, setIsOpen, onClickButton }) => {
	const isHigherThan768 = useMediaQuery('(min-width: 768px)');

	return (
		<Modal shouldCloseOnOverlayClick allowScroll isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
			<S.ModalContainer>
				<Typography tag={isHigherThan768 ? 'h1' : 'h3'} weight="bold" center>
					Account Pending
				</Typography>
				<S.ParaContainer>
					<Typography tag={isHigherThan768 ? 'p' : 'h6'} variation="1" center>
						Thank you for your application. A Customer Service Advisor will review your request and promptly respond during business hours.
					</Typography>
				</S.ParaContainer>
				<Button variant="solid" onClick={onClickButton}>
					<Typography tag="span" variation={isHigherThan768 ? '1' : '2'} weight="extrablack">
						Done
					</Typography>
				</Button>
			</S.ModalContainer>
		</Modal>
	);
};
export default NewCustomerAccountPendingPopup;

NewCustomerAccountPendingPopup.propTypes = {
	isOpen: PropTypes.bool?.isRequired,
	setIsOpen: PropTypes.func?.isRequired,
	onClickButton: PropTypes.func?.isRequired,
};
